module.exports = {"451424100":"桃城镇","451424101":"全茗镇","451424102":"雷平镇","451424103":"硕龙镇","451424104":"下雷镇","451424200":"五山乡","451424201":"龙门乡","451424202":"昌明乡","451424203":"福隆乡","451424204":"那岭乡","451424205":"恩城乡","451424206":"榄圩乡","451424207":"宝圩乡","451424208":"堪圩乡","451424400":"国营桃城华侨农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451424.json
// module id = 2004
// module chunks = 0